// extracted by mini-css-extract-plugin
export var required = "_pa-0";